import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  ALL_ROLE_FILTER_VALUE,
  type PartyRoleFilter,
  type PartyViewMode,
} from "../parties.constants";
import { PartyViewToggle } from "./PartyViewToggle";

interface PartiesToolbarProps {
  search: string;
  roleFilter: PartyRoleFilter;
  viewMode: PartyViewMode;
  total: number;
  onSearchChange: (value: string) => void;
  onRoleFilterChange: (value: PartyRoleFilter) => void;
  onViewModeChange: (mode: PartyViewMode) => void;
}

export function PartiesToolbar({
  search,
  roleFilter,
  viewMode,
  total,
  onSearchChange,
  onRoleFilterChange,
  onViewModeChange,
}: PartiesToolbarProps) {
  return (
    <div className="mb-4 flex flex-col gap-3 border-y border-border py-3 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex flex-1 flex-col gap-2 sm:flex-row">
        <Input
          placeholder="Rechercher par nom, email, téléphone, code..."
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          className="max-w-md"
        />
        <Select
          value={roleFilter || ALL_ROLE_FILTER_VALUE}
          onValueChange={(value) =>
            onRoleFilterChange(
              value === ALL_ROLE_FILTER_VALUE ? "" : (value as Exclude<PartyRoleFilter, "">),
            )
          }
        >
          <SelectTrigger className="w-40">
            <SelectValue placeholder="Tous" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value={ALL_ROLE_FILTER_VALUE}>Tous</SelectItem>
            <SelectItem value="client">Clients</SelectItem>
            <SelectItem value="referrer">Référents</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center justify-between gap-3">
        <p className="text-[11.5px] text-muted-foreground">
          {total} résultat{total !== 1 ? "s" : ""}
        </p>
        <PartyViewToggle viewMode={viewMode} onViewModeChange={onViewModeChange} />
      </div>
    </div>
  );
}
